import { useParams } from "react-router-dom";
import { useSuperAdminUserRole } from "../../../../context/SuperAdmin/UserRoleContext";
import { Box, Button, Modal, Typography } from "@mui/material";
import CurrentUsersDropdown from "./CurrentUsersDropdown";
import OtherUsersMenu from "./OtherUsersMenu";

const AddUserModal = () => {
  const { idRol } = useParams();
  const {
    toAddUsers,
    setToAddUsers,
    toggleAddModal,
    isAdding,
    isAddModalOpen,
    isLoadingAllUsers,
    submitSelections,
  } = useSuperAdminUserRole();

  const handleSubmit = () => {
    if (idRol) {
      submitSelections({ id_rol: idRol, id_usuarios: toAddUsers });
      setToAddUsers([]);
    }
  };

  const handleClose = () => {
    if (!isAdding) {
      toggleAddModal(false);
    }
  };

  return (
    <Modal
      open={isAddModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "700px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        {isLoadingAllUsers ? (
          <Typography
            id="edit-subscription-modal-title"
            justifyContent={"center"}
            sx={{
              width: 1,
              textAlign: "center",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            Cargando...
          </Typography>
        ) : (
          <>
            <CurrentUsersDropdown />
            <OtherUsersMenu />

            <Box sx={{ textAlign: "right" }}>
              <Button
                variant="contained"
                sx={{ background: "#336B87" }}
                disabled={isAdding || !toAddUsers.length}
                onClick={handleSubmit}
              >
                Agregar
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default AddUserModal;
